import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen container mx-auto px-6 pt-20">
      <h1 className="text-4xl font-bold text-gray-800 mt-4">Contact Us</h1>
      <p className="mt-4 text-gray-600">
        We would love to hear from you. Please contact us at:
      </p>
      <p className="mt-4 text-gray-600">
        Email: chris@haulradar.com
      </p>
      <p className="mt-4 text-gray-600">
        Phone: +1-506-869-0897
      </p>
    </div>
  );
};

export default Contact;
